import * as React from 'react';

const ContactLensMetaData = ({ colorLens , replacementFrequency , packageQuantity , labels  })=>/*#__PURE__*/ React.createElement("div", {
        className: "line-item__contact-lens-meta"
    }, colorLens && /*#__PURE__*/ React.createElement("span", {
        className: "line-item__contact-lens-meta-value"
    }, colorLens), replacementFrequency && /*#__PURE__*/ React.createElement("span", {
        className: "line-item__contact-lens-meta-value"
    }, replacementFrequency), packageQuantity && /*#__PURE__*/ React.createElement("span", {
        className: "line-item__contact-lens-meta-value"
    }, `${packageQuantity} ${labels.productsUnitContactLenses} ${labels.productsPerBox}`))
;

export { ContactLensMetaData };
//# sourceMappingURL=ContactLensMetaData.js.map
